import React from 'react';
import classNames from 'classnames/bind';
import EventIcon from '../../EventIcon';
import styles from '../index.pcss';
import GifToVideo from '../../../../../components/mobile/GifToVideo';

interface EventBannerProps {
  platform: string;
  bannerUrl: string;
  eventIcon: string;
}

const cx = classNames.bind(styles);

const EventBanner = (props: EventBannerProps): JSX.Element | null => {
  const { bannerUrl = '', eventIcon = '', platform = '' } = props;

  if (!bannerUrl) return null;

  return (
    <section
      className={cx(
        'section',
        `${platform === 'website' ? 'desk-image-section' : 'image-section'}`
      )}
    >
      <GifToVideo className={cx('flag-hanging-banner')} src={bannerUrl} alt="sale banner" />
      <EventIcon eventIcon={eventIcon} />
    </section>
  );
};

export default EventBanner;
